import api, { armorAPI } from '~/services/api';
import { type JSONLabelSetting } from '~/types/LabelSettings';
import { type JSONUser } from '~/types/User';

export const saveLabelSettings = (payload) =>
  armorAPI.request({
    data: payload,
    method: 'POST',
    url: `/setting/label`,
  });

export const patchLabelSettings = (payload: Partial<JSONLabelSetting>) =>
  armorAPI.request<JSONLabelSetting>({
    data: payload,
    method: 'PATCH',
    url: `/setting/label`,
  });

export const fetchLabelSettings = () =>
  armorAPI.request<JSONLabelSetting>({
    method: 'GET',
    url: `/setting/label`,
  });

export const saveDefaultServiceLevel = (defaultServiceLevel, defaultReturnServiceLevel) => {
  const data: Record<string, string> = {};
  if (defaultServiceLevel) data.default_service_level = defaultServiceLevel;
  if (defaultReturnServiceLevel) data.default_return_service_level = defaultReturnServiceLevel;
  return api.request({
    data,
    method: 'PATCH',
    url: 'v1/ui/account',
  });
};

export const updateUserAccount = (data: Partial<JSONUser>) =>
  api.request<JSONUser>({
    data,
    method: 'PATCH',
    url: 'v1/ui/account',
  });

export const closeAccount = (payload) =>
  armorAPI.request({
    data: payload,
    method: 'POST',
    url: `/setting/close-account`,
    validateStatus: (status) => status === 200 || status === 201 || status === 400,
    withCredentials: true,
  });

export default {
  closeAccount,
  fetchLabelSettings,
  patchLabelSettings,
  saveDefaultServiceLevel,
  saveLabelSettings,
};
